import { Auth as amplifyAuth } from 'aws-amplify'

const axiosHook = (signOut) => async (request) => {
  try {
    const accessToken = (await amplifyAuth.currentSession())?.idToken?.jwtToken

    if (!accessToken) {
      throw new Error('User not authenticated')
    }
    if (accessToken) {
      request.headers.Authorization = `Bearer ${accessToken}`
    }
  } catch (e) {
    signOut()
  }
  return request
}

export default axiosHook
